import { render } from "./VisualizaçãoProtocolo.vue?vue&type=template&id=672538bc"
import script from "./VisualizaçãoProtocolo.vue?vue&type=script&lang=js"
export * from "./VisualizaçãoProtocolo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__